module.exports = __webpack_public_path__ + "img/swap-box-line.21d51739.svg";